"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const dialog_1 = require("@angular/material/dialog");
const dnaR_action_modal_component_1 = require("../../common/components/dnaR-action-modal/dnaR-action-modal.component");
const independent_living_service_1 = require("../services/independent-living.service");
const dnaRSnackBar_service_1 = require("../../common/dna-r/dnaRSnackBar.service");
const core_2 = require("@uirouter/core");
require("../dtos/resident-dto");
const ilu_admission_dto_1 = require("../dtos/ilu-admission-dto");
const view_enquiry_dto_1 = require("../dtos/view-enquiry-dto");
const moment = require("moment");
const common_1 = require("@angular/common");
const _ = require("underscore");
const i0 = require("@angular/core");
const i1 = require("@uirouter/core");
const i2 = require("../services/independent-living.service");
const i3 = require("@angular/material/dialog");
const i4 = require("../../common/dna-r/dnaRSnackBar.service");
const i5 = require("@angular/common");
const i6 = require("@angular/material/button");
const i7 = require("@angular/material/tooltip");
const i8 = require("@angular/material/icon");
const i9 = require("../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i10 = require("@angular/forms");
const i11 = require("../../common/components/dnaR-timePicker/dnaR-timePicker.component");
const i12 = require("../../common/components/dnaR-search/dnaR-search.component");
function AddToUnitModalComponent_h3_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 27);
    i0.ɵɵtext(1, "Admit to unit");
    i0.ɵɵelementEnd();
} }
function AddToUnitModalComponent_h3_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 27);
    i0.ɵɵtext(1, "Correct admission");
    i0.ɵɵelementEnd();
} }
function AddToUnitModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.residentName, " ");
} }
function AddToUnitModalComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "i", 11);
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Resident ");
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵelementStart(5, "dnaR-search", 30);
    i0.ɵɵlistener("valueChange", function AddToUnitModalComponent_div_13_Template_dnaR_search_valueChange_5_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.receiveSelectedResult($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("validate", ctx_r3.submitted);
} }
function AddToUnitModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4, "Warning. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 35);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", ctx_r4.residentName, "'s fees and charges will be abandoned on admission.");
} }
function AddToUnitModalComponent_button_58_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function AddToUnitModalComponent_button_58_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.admissionReversal(); });
    i0.ɵɵtext(1, "Reverse");
    i0.ɵɵelementEnd();
} }
function AddToUnitModalComponent_button_61_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function AddToUnitModalComponent_button_61_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.submit(); });
    i0.ɵɵtext(1, "Admit");
    i0.ɵɵelementEnd();
} }
function AddToUnitModalComponent_button_62_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function AddToUnitModalComponent_button_62_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.submit(); });
    i0.ɵɵtext(1, "Save changes");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "pannel-extra-tall": a0 }; };
class AddToUnitModalComponent {
    constructor($state, independentLivingService, dialogRef, dialog, snackBarService, datePipe) {
        this.$state = $state;
        this.independentLivingService = independentLivingService;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.snackBarService = snackBarService;
        this.datePipe = datePipe;
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false,
            showClearSelectedItems: false
        };
        this.submitted = false;
        this.residentName = null;
        this.admitHeader = "Admit to unit";
        this.reverseHeader = "Reverse admission";
        this.correctHeader = "Correct admission";
        this.hasReverseEventPermission = false;
    }
    ngOnInit() {
        this.maxDate = new Date();
        this.residents = this.enquiry.residents;
        //Current resident may not be the responsible resident for unit, e.g. if this is a departed resident and we
        //are correcting the admission of the resident who is not the responsible resident
        this.currentResidentDetails = this.residents.length === 1 ? this.residents[0] : this.residents.find(x => x.isResidentResponsible);
        this.responsibleForUnitCosts = this.buildResidentFullName(this.currentResidentDetails);
        this.responsibleResidencyId = this.currentResidentDetails.residencyId;
        if (this.isCorrection) {
            this.residentToCorrect = this.enquiry.residents.find(x => x.residencyId === this.residencyId);
            this.residentName = this.buildResidentFullName(this.residentToCorrect);
            this.dateOfBirth = moment(this.residentToCorrect.dateOfBirth, "DD/MM/YYYY").toDate();
            this.admissionDate = new Date(new Date(this.latestAdmissionDate).setHours(0, 0, 0, 0));
            this.admissionTime = this.residentToCorrect.admissionTimeLocal;
            this.otherResident = this.enquiry.residents.find(x => x.residencyId !== this.residencyId);
            this.setOtherResidentAdmissionDateMidnight();
            this.independentLivingService.getFeesAndCharges(this.enquiry.enquiryId, false, this.residentToCorrect.id).then(result => {
                var _a;
                let origAdmissionDate = (_a = result.iluResidencyFinanceFees.find(x => x.residencyId === this.residencyId)) === null || _a === void 0 ? void 0 : _a.admissionDateUtc;
                this.originalAdmissionDate = new Date(new Date(origAdmissionDate).setHours(0, 0, 0, 0));
            });
        }
    }
    setOtherResidentAdmissionDateMidnight() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.otherResident !== undefined) {
                yield this.independentLivingService.getFeesAndCharges(this.enquiry.enquiryId, false, this.otherResident.id).then(result => {
                    var _a;
                    this.otherResidentFeesAndCharges = result;
                    this.otherResidentAdmissionDateMidnight = new Date(new Date((_a = this.otherResidentFeesAndCharges.iluResidencyFinanceFees.find(x => x.residencyId === this.otherResident.residencyId)) === null || _a === void 0 ? void 0 : _a.admissionDateUtc).setHours(0, 0, 0, 0));
                }, () => {
                    this.snackBarService.failure("Unexpected error while getting fees and charges.");
                });
            }
        });
    }
    cancel() {
        this.hideDialogEvent();
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.submitted = true;
            //This if block must remain after submitted is set to true, otherwise the error messages won't be shown in the UI
            if (this.dateOfBirth === undefined || this.dateOfBirth === null || this.admissionDate === undefined || this.admissionDate === null || this.admissionTime === undefined || this.admissionTime === null || this.residentName === undefined || this.residentName === null) {
                return;
            }
            const isAdmissionCorrectionDateValid = !this.isCorrection ? false : yield this.validateAdmissionCorrectionDate();
            const isAdmissionDateValid = this.isCorrection ? false : yield this.validateAdmissionDate();
            if ((this.isCorrection && !isAdmissionCorrectionDateValid) || (!this.isCorrection && !isAdmissionDateValid)) {
                //If validation fails don't continue making changes (the validation fail will cause an error dialog to be shown
                //and we return to the admission/correction/reversal dialog so the user can correct the data)
                return;
            }
            let iluAdmssionDto = new ilu_admission_dto_1.IluAdmissionDto();
            iluAdmssionDto.accommodationId = this.enquiry.assignedUnit.accommodationId;
            iluAdmssionDto.iluAllocationId = this.enquiry.enquiryId;
            //Transform the admission date to the same format used to save the admission date in the db, otherwise the date shown is off by one:
            let admissionDateUtc = new Date(Date.UTC(this.admissionDate.getFullYear(), this.admissionDate.getMonth(), this.admissionDate.getDate(), 0, 0, 0, 0));
            iluAdmssionDto.admissionDate = admissionDateUtc;
            iluAdmssionDto.admissionTimeLocal = this.admissionTime.toString();
            iluAdmssionDto.responsibleResidencyId = this.responsibleResidencyId;
            iluAdmssionDto.price = this.enquiry.assignedUnit.price;
            iluAdmssionDto.residentDetails = [];
            iluAdmssionDto.residentDetails.push({ residentId: (this.isCorrection ? this.residentToCorrect.id : this.residentToAdmit.id), dateOfBirth: this.dateOfBirth.toLocaleString('en-GB').split(',')[0] });
            if (this.isCorrection) {
                let residencyIdToCorrect = this.residencyId;
                this.independentLivingService.correctAdmission(residencyIdToCorrect, iluAdmssionDto).then(result => {
                    this.snackBarService.success("Admission correction successful.");
                    this.hideDialogEvent();
                    if (this.onModalCloseCallback != null)
                        this.onModalCloseCallback('iluAdmissionCorrected');
                }, (error) => {
                    if (!error.modelStateSummary) {
                        this.snackBarService.failure("Unexpected error while correcting admission to independent living unit.");
                    }
                    else {
                        let textMessage = "Admission cannot be corrected. " + _.values(error.modelStateSummary) + "\n";
                        this.displayErrorDialog(this.correctHeader, textMessage);
                    }
                });
            }
            else {
                this.independentLivingService.addToUnit(iluAdmssionDto, this.residentToAdmit.residencyId).then(result => {
                    this.snackBarService.success(this.residentToAdmit.firstName + " " + this.residentToAdmit.lastName.toUpperCase() + " admitted");
                    this.hideDialogEvent();
                    if (this.residentToAdmit.id != 0) {
                        this.$state.go("viewIndependentLivingAllocation", { enquiryId: this.enquiry.enquiryId, residentId: this.residentToAdmit.id });
                    }
                }, (error) => {
                    if (!error.modelStateSummary) {
                        this.snackBarService.failure("Unexpected error while admitting to independent living unit.");
                    }
                    else {
                        let textMessage = "Resident cannot be admitted. " + _.values(error.modelStateSummary);
                        this.displayErrorDialog(this.admitHeader, textMessage);
                    }
                });
            }
        });
    }
    admissionReversal() {
        if (this.residentToCorrect.departureDateUtc !== null) {
            const departedResidentErrorDialogData = {
                title: "Reverse admission",
                text: `Unable to reverse admission. \n Resident ${this.residentToCorrect.firstName} ${this.residentToCorrect.lastName.toUpperCase()} is departed.`,
                action: "Ok",
                actionButtonClass: "btn-primary",
                hideCancelButton: true,
                actionFunction: () => {
                    this.dialog.ngOnDestroy();
                }
            };
            this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                panelClass: 'custom-dialog-container',
                width: '456px',
                height: '250px',
                data: departedResidentErrorDialogData
            });
        }
        else {
            let confirmationMessage = "Are you sure you want to reverse admission?";
            let height = '250px';
            if (this.otherResident !== undefined) {
                let otherResidentName = this.buildResidentFullName(this.otherResident);
                const confirmationDialogData = {
                    title: "Reverse admission",
                    text: `${confirmationMessage} \n`,
                    action: "Reverse",
                    actionButtonClass: "modal-danger-button",
                    actionFunction: () => this.reverseAdmission(this.residencyId)
                };
                const responsibilityTransferDialogData = {
                    title: "Reverse admission",
                    text: `Responsibility for unit costs will be transferred to \n ${otherResidentName}. \n\n ${confirmationMessage}`,
                    action: "Reverse",
                    actionButtonClass: "modal-danger-button",
                    actionFunction: () => this.reverseAdmission(this.residencyId)
                };
                const noNewBillPayerDialogData = {
                    title: "Reverse admission",
                    text: `Admission cannot be reversed. \n Please select a bill payer for ${otherResidentName} to pay for the unit costs.`,
                    action: "Ok",
                    actionButtonClass: "btn-primary",
                    hideCancelButton: true,
                    actionFunction: () => {
                        this.dialog.ngOnDestroy();
                    }
                };
                const reverseAdmissionBothResidentsconfirmationDialogData = {
                    title: "Reverse admission",
                    text: `${otherResidentName}'s will also be reversed. \n Are you sure you want to reverse admission?`,
                    action: "Reverse",
                    actionButtonClass: "modal-danger-button",
                    actionFunction: () => this.reverseAdmission(0)
                };
                var dialogData = confirmationDialogData;
                //reverse both residents if we are reversing the first resident to occupy the unit or if both residents were added on the same day:
                if (this.admissionDate <= this.otherResidentAdmissionDateMidnight) {
                    dialogData = reverseAdmissionBothResidentsconfirmationDialogData;
                }
                else {
                    if (!this.otherResidentFeesAndCharges.iluResidencyFinanceFees.find(x => x.residencyId !== this.residencyId).isBillPayerDefined) {
                        dialogData = noNewBillPayerDialogData;
                        height = '274px';
                    }
                    else if (this.residencyId === this.responsibleResidencyId && this.otherResidentFeesAndCharges.iluResidencyFinanceFees.find(x => x.residencyId !== this.residencyId).isBillPayerDefined) {
                        dialogData = responsibilityTransferDialogData;
                        height = '298px';
                    }
                }
                this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                    panelClass: 'custom-dialog-container',
                    width: '456px',
                    height: height,
                    data: dialogData
                });
            }
            else {
                //No other resident left, so reverse the admission as usual (without specifying a residencyId):
                const confirmationDialogData = {
                    title: "Reverse admission",
                    text: `${confirmationMessage} \n`,
                    action: "Reverse",
                    actionButtonClass: "modal-danger-button",
                    actionFunction: () => this.reverseAdmission(0)
                };
                var dialogData = confirmationDialogData;
                this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                    panelClass: 'custom-dialog-container',
                    width: '456px',
                    height: height,
                    data: dialogData
                });
            }
        }
    }
    reverseAdmission(residencyId) {
        this.independentLivingService.reverseAdmission(this.enquiry.assignedUnit.independentLivingAllocationId, residencyId).then(result => {
            this.snackBarService.success("Admission reversed");
            this.hideDialogEvent();
            let enquiryId = this.enquiry.enquiryId;
            let residentId = this.residentToCorrect.id;
            if (residencyId !== 0) {
                //If residencyId is not null then we are reversing the admission of the second resident so need to get the other enquiry id:
                this.independentLivingService.getEnquiryIdByResidencyId(residencyId).then(res => {
                    enquiryId = res;
                    this.onModalCloseCallback('iluAdmissionReversed', residentId, enquiryId);
                });
            }
            else {
                this.onModalCloseCallback('iluAdmissionReversed', residentId, enquiryId);
            }
        }, (error) => {
            if (!error.modelStateSummary) {
                this.snackBarService.failure("Unexpected error while reversing admission.");
            }
            else {
                let textMessage = "Admission cannot be reversed. " + _.values(error.modelStateSummary);
                this.displayErrorDialog(this.reverseHeader, textMessage);
            }
        });
    }
    receiveSelectedResult($event) {
        if ($event !== null) {
            this.residentToAdmit = $event.valueOf();
            this.dateOfBirth = $event.dateOfBirth !== null ? new Date($event.valueOf().dateOfBirth) : null;
            this.residentName = this.buildResidentFullName($event.valueOf());
        }
        else {
            this.residentToAdmit = null;
            this.dateOfBirth = null;
            this.residentName = null;
        }
    }
    buildResidentFullName(resident) {
        if (resident !== null && resident !== undefined) {
            let preferredName = resident.preferredName !== null ? ` (${resident.preferredName})` : '';
            return resident.firstName + ' ' + resident.lastName.toUpperCase() + (preferredName !== '' ? preferredName : '');
        }
        return null;
    }
    validateAdmissionDate() {
        return __awaiter(this, void 0, void 0, function* () {
            let currentResidentAdmissionDate = new Date(this.enquiry.occupiedDate);
            currentResidentAdmissionDate.setHours(0, 0, 0, 0);
            if (this.admissionDate < currentResidentAdmissionDate) {
                const formatedDateString = this.formatDateString(currentResidentAdmissionDate);
                const textMessage = "Resident cannot be admitted. \nAdmission date must be after or equal to " + this.currentResidentDetails.firstName + ' ' + this.currentResidentDetails.lastName.toUpperCase() + "'s admission date: " + formatedDateString;
                this.displayErrorDialog(this.admitHeader, textMessage);
                return false;
            }
            if (this.currentResidentDetails.departureDateUtc !== null && this.currentResidentDetails.departureDateUtc < this.admissionDate) {
                const formatedDateString = this.formatDateString(this.currentResidentDetails.departureDateUtc);
                const textMessage = "Resident cannot be admitted. \nAdmission date must be before or equal to " + this.currentResidentDetails.firstName + ' ' + this.currentResidentDetails.lastName.toUpperCase() + "'s departure date: " + formatedDateString;
                this.displayErrorDialog(this.admitHeader, textMessage);
                return false;
            }
            let self = this;
            //show error dialog if admission date is before a period when unit has another resident after current resident admission date that is not departed or departed before the requested admission date:
            //(if no departure dates or latest departure date is after requested admission date or trying to admit after current resident's departure date then show error)
            let currentResidentAdmissionDateUtc = new Date(Date.UTC(currentResidentAdmissionDate.getFullYear(), currentResidentAdmissionDate.getMonth(), currentResidentAdmissionDate.getDate(), 0, 0, 0, 0));
            return yield this.independentLivingService.getLatestResidencyDepartedFromUnit(this.enquiry.assignedUnit.independentLivingAllocationId, this.currentResidentDetails.residencyId, currentResidentAdmissionDateUtc).then((result) => {
                if (result !== null && result.lastName !== null) {
                    let departureDate = result.departureDateUtc !== null ? new Date(result.departureDateUtc) : null;
                    if (departureDate !== null) {
                        departureDate.setHours(0, 0, 0, 0);
                    }
                    if (departureDate === null || departureDate > self.admissionDate) {
                        let textMessage = "";
                        if (departureDate === null) {
                            textMessage = "Resident cannot be admitted. \nResident " + result.firstName + ' ' + result.lastName.toUpperCase() + " is also currently in this unit.";
                        }
                        else {
                            const formatedDateString = this.formatDateString(departureDate);
                            textMessage = "Resident cannot be admitted. \nAdmission date must be after or equal to " + result.firstName + ' ' + result.lastName.toUpperCase() + "'s departure date: " + formatedDateString;
                        }
                        this.displayErrorDialog(this.admitHeader, textMessage);
                        return false;
                    }
                    return true;
                }
                return true;
            });
        });
    }
    validateAdmissionCorrectionDate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.residentToCorrect.departureDateUtc !== null) {
                var residentToCorrectDepartureDateUtc = new Date(new Date(this.residentToCorrect.departureDateUtc).setHours(0, 0, 0, 0));
                if (this.admissionDate > residentToCorrectDepartureDateUtc) {
                    //Cannot correct admission to a date after the resident's departure date:
                    const formatedDateString = this.formatDateString(this.residentToCorrect.departureDateUtc);
                    const textMessage = "Admission cannot be corrected. \nAdmission date must be before or equal to " + this.buildResidentFullName(this.residentToCorrect) + "'s departure date: " + formatedDateString;
                    this.displayErrorDialog(this.correctHeader, textMessage);
                    return false;
                }
            }
            //Ensure we are not correcting the admission date to a date when the unit was occupied by someone else:
            let noPreviousResidentOnAdmissionDate = yield this.independentLivingService.getLatestResidencyAdmittedToUnitBeforeDate(this.enquiry.assignedUnit.independentLivingAllocationId, this.residencyId, this.admissionDate).then((result) => __awaiter(this, void 0, void 0, function* () {
                if (result !== null && result.lastName !== null) {
                    let previousResidentDepartureDate = null;
                    if (result.departureDateUtc !== null) {
                        previousResidentDepartureDate = new Date(result.departureDateUtc);
                        previousResidentDepartureDate.setHours(0, 0, 0, 0);
                    }
                    if (previousResidentDepartureDate === null || previousResidentDepartureDate > this.admissionDate) {
                        //Unit is unavailable (occupied by other previous resident before or during the new admission date):
                        const formatedDateString = this.formatDateString(previousResidentDepartureDate);
                        const textMessage = "Admission cannot be corrected. \nAdmission date must be after or equal to " + result.firstName + ' ' + result.lastName.toUpperCase() + " departure date: " + formatedDateString;
                        this.displayErrorDialog(this.correctHeader, textMessage);
                        return false;
                    }
                    return true;
                }
                return true;
            }), (error) => {
                if (!error.modelStateSummary) {
                    this.snackBarService.failure("Unexpected error while checking for previous residencies before the admission date.");
                    return false;
                }
                else {
                    let textMessage = "Unexpected error while checking for previous residencies before the admission date. " + _.values(error.modelStateSummary);
                    this.displayErrorDialog(this.admitHeader, textMessage);
                    return false;
                }
            });
            if (!noPreviousResidentOnAdmissionDate) {
                return false;
            }
            if (this.otherResident !== undefined) {
                let formattedOccupiedDate = new Date(new Date(this.enquiry.occupiedDate).setHours(0, 0, 0, 0));
                //Correcting admission date of first resident in the unit:
                if (this.otherResidentAdmissionDateMidnight > formattedOccupiedDate) {
                    if (this.admissionDate > this.otherResidentAdmissionDateMidnight) {
                        //cannot change the admission date of the first resident to a date after the second resident admission date:
                        const formatedDateString = this.formatDateString(this.otherResidentAdmissionDateMidnight);
                        const textMessage = "Admission cannot be corrected. \nAdmission date must be before or equal to " + this.buildResidentFullName(this.otherResident) + "'s admission date: " + formatedDateString;
                        this.displayErrorDialog(this.correctHeader, textMessage);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else if (this.otherResidentAdmissionDateMidnight.getTime() == this.originalAdmissionDate.getTime()) {
                    //Both residents were admitted on the same day:
                    return true;
                }
                else {
                    //Correcting admission date of second resident in the unit:
                    if (this.admissionDate < this.otherResidentAdmissionDateMidnight) {
                        const formatedDateString = this.formatDateString(this.otherResidentAdmissionDateMidnight);
                        const textMessage = "Admission cannot be corrected. \nAdmission date must be after or equal to " + this.buildResidentFullName(this.otherResident) + "'s admission date: " + formatedDateString;
                        this.displayErrorDialog(this.correctHeader, textMessage);
                        return false;
                    }
                    else {
                        let res = yield this.independentLivingService.getLatestResidencyDepartedFromUnit(this.enquiry.assignedUnit.independentLivingAllocationId, this.residencyId, formattedOccupiedDate).then((result) => __awaiter(this, void 0, void 0, function* () {
                            if (result !== null && result.lastName !== null) {
                                //Correcting admission date of second resident in the unit when there was another second resident in the unit before this one:
                                let departureDate = result.departureDateUtc !== null ? new Date(result.departureDateUtc) : null;
                                let textMessage = "";
                                if (departureDate !== null && new Date(departureDate.setHours(0, 0, 0, 0)) > this.admissionDate) {
                                    const formatedDateString = this.formatDateString(departureDate);
                                    textMessage = "Admission cannot be corrected. \nAdmission date must be after or equal to " + result.firstName + ' ' + result.lastName.toUpperCase() + " departure date: " + formatedDateString;
                                    this.displayErrorDialog(this.correctHeader, textMessage);
                                    return false;
                                }
                                return true;
                            }
                            return true;
                        }), (error) => {
                            if (!error.modelStateSummary) {
                                this.snackBarService.failure("Unexpected error while checking for the latest residency departed from the unit.");
                                return false;
                            }
                            else {
                                let textMessage = "Unexpected error while checking for the Unexpected error while checking for latest residency departed from the unit. " + _.values(error.modelStateSummary);
                                this.displayErrorDialog(this.admitHeader, textMessage);
                                return false;
                            }
                        });
                        return res;
                    }
                }
            }
            //Only one resident: No validation required, so return true:
            return true;
        });
    }
    displayErrorDialog(headerText, textMessage) {
        const dialogData = {
            title: headerText,
            text: textMessage,
            action: "Ok",
            actionButtonClass: "btn-primary",
            hideCancelButton: true,
            actionFunction: () => {
                this.dialog.ngOnDestroy();
            }
        };
        this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
            panelClass: 'custom-dialog-container',
            width: 'auto',
            height: '275px',
            data: dialogData
        });
    }
    formatDateString(date) {
        return this.datePipe.transform(date, 'dd-MMM-yyyy');
    }
}
exports.AddToUnitModalComponent = AddToUnitModalComponent;
AddToUnitModalComponent.ɵfac = function AddToUnitModalComponent_Factory(t) { return new (t || AddToUnitModalComponent)(i0.ɵɵdirectiveInject(i1.StateService), i0.ɵɵdirectiveInject(i2.IndependentLivingService), i0.ɵɵdirectiveInject(i3.MatDialogRef), i0.ɵɵdirectiveInject(i3.MatDialog), i0.ɵɵdirectiveInject(i4.DnaRSnackBarService), i0.ɵɵdirectiveInject(i5.DatePipe)); };
AddToUnitModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddToUnitModalComponent, selectors: [["add-to-unit-modal"]], inputs: { hideDialogEvent: "hideDialogEvent", enquiry: "enquiry", isCorrection: "isCorrection", hasReverseEventPermission: "hasReverseEventPermission", residencyId: "residencyId", latestAdmissionDate: "latestAdmissionDate", onModalCloseCallback: "onModalCloseCallback" }, decls: 63, vars: 32, consts: [[1, "modal-dialog", "angular-dialog", "admit-to-unit"], [1, "body"], ["mat-dialog-title", "", 1, "modal-header", "modal-header-action"], [1, "col-xs-11", "noSidePadding", "header-title"], ["class", "modal-title title", 4, "ngIf"], [1, "col-xs-1", "noSidePadding"], ["mat-icon-button", "", "matTooltip", "Cancel", "role", "button", "matTooltipClass", "mat-tooltip", 1, "modal-header", "close-modal", "pull-right", 3, "click"], [1, "icon", "icon-close-fill", "close-modal-icon"], [3, "ngClass"], ["class", "left-panel panel-resident-name", 4, "ngIf"], ["class", "left-panel panel-small", 4, "ngIf"], [1, "required"], [1, "component-container"], ["name", "effectiveDate", "ngDefaultControl", "", "required", "true", "requiredError", "Date of birth required", 3, "ngModel", "validate", "max", "ngModelChange"], ["class", "fees-warning", 4, "ngIf"], [1, "unit-info"], [1, "left-panel", "panel-tall"], [1, "data-field"], [1, "right-panel", "panel-tall"], [1, "panel-tall"], ["name", "admissionDate", "ngDefaultControl", "", "required", "true", "requiredError", "Admission date required", 3, "ngModel", "validate", "max", "ngModelChange"], ["name", "admissionTimeLocal", "required", "", 3, "isRequired", "helperText", "ngModel", "defaultOpen", "formSubmitted", "ngModelChange"], [1, "modal-footer", "col-xs-12"], [1, "btn-group-md"], ["type", "button", "class", "btn btn-danger btn-lg btn-inline-block-md reverse", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-warning", "modal-warning-button", 3, "click"], ["type", "submit", "class", "btn btn-primary modal-action-button", 3, "click", 4, "ngIf"], [1, "modal-title", "title"], [1, "left-panel", "panel-resident-name"], [1, "left-panel", "panel-small"], ["showClearSelectedItems", "true", "placeholder", "Search prospect", "isRequired", "true", "requiredError", "Resident required", "maxResults", "10", 3, "validate", "valueChange"], [1, "fees-warning"], [1, "fees-warning-message"], [1, "alert-warning", "warning-icon", "fees-and-charges"], [1, "message-text", "warning"], [1, "message-text"], ["type", "button", 1, "btn", "btn-danger", "btn-lg", "btn-inline-block-md", "reverse", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", "modal-action-button", 3, "click"]], template: function AddToUnitModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, AddToUnitModalComponent_h3_4_Template, 2, 0, "h3", 4);
        i0.ɵɵtemplate(5, AddToUnitModalComponent_h3_5_Template, 2, 0, "h3", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "button", 6);
        i0.ɵɵlistener("click", function AddToUnitModalComponent_Template_button_click_7_listener() { return ctx.cancel(); });
        i0.ɵɵelement(8, "mat-icon", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtemplate(12, AddToUnitModalComponent_div_12_Template, 2, 1, "div", 9);
        i0.ɵɵtemplate(13, AddToUnitModalComponent_div_13_Template, 6, 1, "div", 10);
        i0.ɵɵelementStart(14, "div", 8);
        i0.ɵɵelementStart(15, "i", 11);
        i0.ɵɵtext(16, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(17, " Date of birth ");
        i0.ɵɵelementStart(18, "div", 12);
        i0.ɵɵelementStart(19, "dnaR-date-picker", 13);
        i0.ɵɵlistener("ngModelChange", function AddToUnitModalComponent_Template_dnaR_date_picker_ngModelChange_19_listener($event) { return ctx.dateOfBirth = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, AddToUnitModalComponent_div_20_Template, 7, 1, "div", 14);
        i0.ɵɵelement(21, "div", 8);
        i0.ɵɵelementStart(22, "div", 15);
        i0.ɵɵelementStart(23, "div", 16);
        i0.ɵɵelementStart(24, "div");
        i0.ɵɵtext(25, "Unit");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 17);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 18);
        i0.ɵɵelementStart(29, "div");
        i0.ɵɵtext(30, "Max occupancy");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 17);
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 16);
        i0.ɵɵelementStart(34, "div");
        i0.ɵɵtext(35, "Location");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 17);
        i0.ɵɵtext(37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 18);
        i0.ɵɵelementStart(39, "div");
        i0.ɵɵtext(40, "Unit type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 17);
        i0.ɵɵtext(42);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 19);
        i0.ɵɵelementStart(44, "div", 16);
        i0.ɵɵelementStart(45, "i", 11);
        i0.ɵɵtext(46, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(47, " Admission date ");
        i0.ɵɵelementStart(48, "div", 12);
        i0.ɵɵelementStart(49, "dnaR-date-picker", 20);
        i0.ɵɵlistener("ngModelChange", function AddToUnitModalComponent_Template_dnaR_date_picker_ngModelChange_49_listener($event) { return ctx.admissionDate = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 18);
        i0.ɵɵelementStart(51, "i", 11);
        i0.ɵɵtext(52, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(53, " Admission time ");
        i0.ɵɵelementStart(54, "div", 12);
        i0.ɵɵelementStart(55, "dnaR-time-picker", 21);
        i0.ɵɵlistener("ngModelChange", function AddToUnitModalComponent_Template_dnaR_time_picker_ngModelChange_55_listener($event) { return ctx.admissionTime = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 22);
        i0.ɵɵelementStart(57, "div", 23);
        i0.ɵɵtemplate(58, AddToUnitModalComponent_button_58_Template, 2, 0, "button", 24);
        i0.ɵɵelementStart(59, "button", 25);
        i0.ɵɵlistener("click", function AddToUnitModalComponent_Template_button_click_59_listener() { return ctx.cancel(); });
        i0.ɵɵtext(60, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(61, AddToUnitModalComponent_button_61_Template, 2, 0, "button", 26);
        i0.ɵɵtemplate(62, AddToUnitModalComponent_button_62_Template, 2, 0, "button", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.isCorrection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCorrection);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.isCorrection ? "modal-body correction-body" : "modal-body admission-body");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isCorrection ? "correction-body-container" : "admission-body-container");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isCorrection ? "resident-correction" : "resident-admission");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCorrection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isCorrection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isCorrection ? "left-panel panel-resident-dob" : "right-panel panel-small");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.dateOfBirth)("validate", ctx.submitted && (ctx.dateOfBirth === undefined || ctx.dateOfBirth === null))("max", ctx.maxDate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.residentName !== null && !ctx.isCorrection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isCorrection ? "correction-empty-space" : "empty-space");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.enquiry.assignedUnit.unitNumber);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.enquiry.assignedUnit.numberBeds);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.enquiry.assignedUnit.location);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.enquiry.assignedUnit.unitType);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(30, _c0, ctx.submitted && (ctx.admissionDate === undefined || ctx.admissionTime === undefined)));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.admissionDate)("validate", ctx.submitted && (ctx.admissionDate === undefined || ctx.admissionDate === null))("max", ctx.maxDate);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("isRequired", true)("helperText", "Admission time required")("ngModel", ctx.admissionTime)("defaultOpen", false)("formSubmitted", ctx.submitted);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isCorrection && ctx.hasReverseEventPermission);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isCorrection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCorrection);
    } }, directives: [i3.MatDialogTitle, i5.NgIf, i6.MatButton, i7.MatTooltip, i8.MatIcon, i5.NgClass, i9.DnaRDatePicker, i10.DefaultValueAccessor, i10.RequiredValidator, i10.NgControlStatus, i10.NgModel, i11.DnaRTimePicker, i12.DnaRSearch], styles: [".required[_ngcontent-%COMP%] {\n  color: #C53535;\n  padding-right: 2px;\n}\n.admit-to-unit[_ngcontent-%COMP%] {\n  width: 668px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%] {\n  margin: 0px !important;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  \n}\n.admit-to-unit[_ngcontent-%COMP%]   .modal-header.close-modal[_ngcontent-%COMP%] {\n  padding: 0px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .modal-header.close-modal[_ngcontent-%COMP%]:hover, .admit-to-unit[_ngcontent-%COMP%]   .modal-header.close-modal[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%] {\n  padding-top: 10px !important;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]   .reverse[_ngcontent-%COMP%] {\n  float: left;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%] {\n  padding: 26px 0px;\n  margin: 0px;\n  min-height: 482px;\n  width: 668px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%] {\n  min-height: 430px;\n  width: 604px;\n  margin: 0px 32px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%]   .resident-correction[_ngcontent-%COMP%] {\n  min-height: 97px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%]   .resident-correction[_ngcontent-%COMP%]   .panel-resident-name[_ngcontent-%COMP%] {\n  height: 30px;\n  position: absolute;\n  top: 20px;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  font-family: 'Source Sans Pro';\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%]   .resident-correction[_ngcontent-%COMP%]   .panel-resident-dob[_ngcontent-%COMP%] {\n  height: 67px;\n  position: absolute;\n  top: 60px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%]   .correction-empty-space[_ngcontent-%COMP%] {\n  position: relative;\n  height: 72px;\n  width: 604px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .correction-body[_ngcontent-%COMP%]   .correction-body-container[_ngcontent-%COMP%]   .correction-empty-space[_ngcontent-%COMP%]::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 604px;\n  height: 1px;\n  background-color: #D2D2D2;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%] {\n  padding: 26px 0px;\n  margin: 0px;\n  min-height: 460px;\n  width: 668px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%] {\n  min-height: 408px;\n  width: 604px;\n  margin: 0px 32px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .resident-admission[_ngcontent-%COMP%] {\n  width: 100%;\n  min-height: 67px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .fees-warning[_ngcontent-%COMP%] {\n  min-height: 60px;\n  padding-top: 20px;\n  width: 100%;\n  gap: 8px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .fees-warning[_ngcontent-%COMP%]   .fees-warning-message[_ngcontent-%COMP%] {\n  display: flex;\n  height: 40px;\n  width: 604px;\n  padding: 10px;\n  gap: 15px;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n  background-color: #FEF8ED;\n  text-align: center;\n  line-height: 40px;\n  border: 1px solid #F5A623;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .fees-warning[_ngcontent-%COMP%]   .fees-warning-message[_ngcontent-%COMP%]   .message-text[_ngcontent-%COMP%] {\n  height: 22px;\n  text-align: center;\n  line-height: 20px;\n  font-weight: 400;\n  font-size: 14px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .fees-warning[_ngcontent-%COMP%]   .fees-warning-message[_ngcontent-%COMP%]   .message-text.warning[_ngcontent-%COMP%] {\n  color: #414141;\n  font-weight: 600;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%] {\n  position: relative;\n  height: 80px;\n  width: 604px;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .empty-space[_ngcontent-%COMP%]::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 604px;\n  height: 1px;\n  background-color: #D2D2D2;\n}\n.admit-to-unit[_ngcontent-%COMP%]   .admission-body[_ngcontent-%COMP%]   .admission-body-container[_ngcontent-%COMP%]   .responsible-for-costs[_ngcontent-%COMP%] {\n  height: 87px;\n}\n.component-container[_ngcontent-%COMP%] {\n  width: 100%;\n  gap: 4px;\n  position: absolute;\n  top: 33px;\n}\n.component-container[_ngcontent-%COMP%]     .date-picker {\n  background-color: #ffffff !important;\n}\n.component-container[_ngcontent-%COMP%]     .multiselect-dropdown {\n  background-color: #ffffff !important;\n}\n.unit-info[_ngcontent-%COMP%] {\n  height: 174px;\n}\n.left-panel[_ngcontent-%COMP%] {\n  width: 294px;\n  float: left;\n  margin: 0px;\n}\n.right-panel[_ngcontent-%COMP%] {\n  width: 294px;\n  float: right;\n}\n.panel-small[_ngcontent-%COMP%] {\n  height: 67px;\n  position: relative;\n}\n.panel-tall[_ngcontent-%COMP%] {\n  height: 87px;\n  position: relative;\n}\n.pannel-extra-tall[_ngcontent-%COMP%] {\n  height: 107px;\n  position: relative;\n}\n.data-field[_ngcontent-%COMP%] {\n  height: 54px;\n  gap: 4px;\n  position: absolute;\n  top: 33px;\n}\n.warning-icon[_ngcontent-%COMP%] {\n  width: 22px;\n  height: 22px;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: normal;\n}\n.warning-icon.fees-and-charges[_ngcontent-%COMP%] {\n  background-image: url(images/error-fill.svg);\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AddToUnitModalComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'add-to-unit-modal',
                templateUrl: './add-to-unit-modal.component.html',
                styleUrls: ['./add-to-unit-modal.component.less']
            }]
    }], function () { return [{ type: i1.StateService }, { type: i2.IndependentLivingService }, { type: i3.MatDialogRef }, { type: i3.MatDialog }, { type: i4.DnaRSnackBarService }, { type: i5.DatePipe }]; }, { hideDialogEvent: [{
            type: core_1.Input
        }], enquiry: [{
            type: core_1.Input
        }], isCorrection: [{
            type: core_1.Input
        }], hasReverseEventPermission: [{
            type: core_1.Input
        }], residencyId: [{
            type: core_1.Input
        }], latestAdmissionDate: [{
            type: core_1.Input
        }], onModalCloseCallback: [{
            type: core_1.Input
        }] }); })();
